import React, { useState, useEffect } from "react";
import Image from "../../../components/common/Image";
import Toggle from "../../../components/common/toggle";
import Input from "../../../components/common/Input";
import Switch from "../../../components/common/switch/Switch";
import Number from "../../../components/common/Input/Number";
import Accordion from "../../../components/common/accordion";
import Select from "../../../components/common/Select";
import {
  GetExpressway,
  GetExpresswayID,
  GetDivisionAndReststop,
  GetFreewayRegionId,
  GetExpresswayCountyList,
  GetExpresswayByCountyCode,
  GetFreeway,
} from "../../../api/system";
import Checkbox from "../../../components/common/checkbox";
import { GetInfoByAddressOrXY } from "../../../api/map8";

const Position = ({ data, parameters, onSubmit, onBack, County }) => {
  const [submitData, setSubmitData] = useState({});
  const [selectOptions, setSelectOptions] = useState({});
  const [countyOption, setCountyOption] = useState(null);
  const [freeWayOptions, setFreeWayOptions] = useState({});
  const [mileageError, setMileageError] = useState(false);
  const [error, setError] = useState(false);
  const iniValue = { limitHeight: "2.0", floor: 1 };
  const options = [
    {
      id: 1,
      name: "請設置警示並安全等候救援",
      description:
        "請您於車輛後方約50公尺處擺放三角故障牌、閃雙簧警示燈，並且站在人車安全地方，等候我方「全鋒道路救援」安排車輛前往。",
    },
    {
      id: 2,
      name: "請確認接駁安排，避免拖吊延誤",
      description:
        "拖吊車旁邊最多2位乘客乘坐，若您現場超過2人以上，請您先撥打1968，由高公局協助讓乘客離開現場並確認前往接駁車輛的預計到達現場時間，避免拖吊車到場等候您乘客離開的時間，會有待時費用產生，我方司機與您聯絡時，請將接駁車的預計到達現場時間告知拖吊車司機。",
    },
  ];
  const _onSubmit = async () => {
    //選擇國道高速公路 車道中 或 路肩需呼叫 /api/Freeway/GetFreeWayRegionId 查詢高速公路代號
    let obj = { ...submitData };
    // let address = obj.a

    if (submitData.freeway_type?.id > 2) {
      let res = await GetFreewayRegionId({
        freewayListID: submitData.freeway.freewayListID,
        direction: submitData.direction.value,
        km: submitData.mileage,
      });
      if (res?.statusCode === 200) {
        obj.freewayRegionId = res.result.freewayRegionId;
      } else {
        return false;
      }
      setError(false)
    } else if (submitData.position?.id === 3) {
      //取得快速道路識別碼
      if (obj.unseenMileage) {
        obj.expressway_id = { ...obj.expressway_id, expressway_id: "00000" };
      } else {
        let res = await GetExpresswayID({
          expresswayListID: obj.expressway_id.expresswayListID,
          direction: submitData.direction.name,
          km: submitData.mileage,
        });
        if (res?.statusCode === 200) {
          obj.expressway_id = {
            ...obj.expressway_id,
            expressway_id: res.result.expressway_id || "00000",
          };
          obj.address = `${obj.expressway_id.name}${submitData.direction?.name}${submitData.mileage}公里`;
        }
      }
      setError(false)
    } else {
      //平面、停車場
      const res = await GetInfoByAddressOrXY({ address: obj.address })
      if (res?.statusCode == 200) {
        setError(false)
        let result = res.result[0]
        let city = County.filter((c) => c.name === result.city?.replace("台", "臺"))[0]
        obj.position = {
          ...obj.position,
          address: obj.address,
          ...result.geometry.location,
          town: { name: result.town },
          city: { name: result.city?.replace("台", "臺") },
        }
        obj.city = city
        obj.town = { name: result.town }
      } else {
        setError(true)
      }
    }

    //國道高速公路
    if (submitData?.position?.id === 2) {
      //id ===1 國道分隊;  id ===2 休息站
      let freeway = obj.freeway

      if (obj.freeway_type.id < 3) {
        obj.address = `${freeway.name}${obj.freeway_sub.name}${obj.direction?.name}`
        // GetPlaceAutocomplete_keyword =`${data.freeway_type.id===1?data.freeway_sub.typeName:''}${data.freeway_sub.name}${data.direction?.name}` 

      } else {
        obj.address = `${freeway.name}${obj.freeway_type.name}${obj.direction.name}${obj.mileage}公里`
        // GetPlaceAutocomplete_keyword =`${freeway.nickName}-${data.mileage}K`  
      }
    }

    !error && onSubmit(obj);
  };

  const disabledBtn = () => {
    let position = submitData.position;
    let unvalid = true;
    let validation = {
      0: ["address"],
      1: ["address", "type"],
      2: ["freeway", "freeway_type"],
      3: [

        "expressway_id",
        "express_location",
        "direction",
        "mileage",
      ],
      // "address",
    };
    if (position?.id === 0) {
      // 停車場
      // check.push("type")
    } else if (position?.id === 2) {
      //國道高速
      if (submitData.freeway_type?.id > 2) {
        validation["2"].push("direction");
        validation["2"].push("mileage");
      } else {
        validation["2"].push("freeway_sub");
      }
    }
    if (position) {
      let unvalid_arr = [];
      validation[position.id].forEach((key) => {
        if (key === "mileage") {
          if (!submitData.unseenMileage && !submitData[key]) {
            unvalid_arr.push(key);
          }
        } else {
          if (!submitData[key]) unvalid_arr.push(key);
        }
      });
      unvalid = unvalid_arr.length;
    }
    return unvalid;
  };

  const expressList = async (val) => {

    //快速道路清單
    let obj = { ...selectOptions }
    if (!obj.freeWay) {
      let freewayRes = await GetFreeway();
      if (freewayRes?.statusCode === 200) obj.freeway = freewayRes.result;
    }
    let express = await GetExpresswayByCountyCode(val)
    if (express?.statusCode === 200) {
      obj.express = express.result
    }
    setSelectOptions(obj);
  }
  const freeWay = async (obj, reset) => {
    let county = countyOption
    if (!county) {
      let res = await GetExpresswayCountyList();
      if (res?.statusCode === 200) {
        county = res.result.map((r) => ({ ...r, name: r.countyName }));
      }
      setCountyOption(county);
    }
    let option = county.filter((r) => r.countyName === obj.city.name);
    if (option.length) {
      let countyCode = option[0]["countyCode"]
      obj.city = { ...obj.city, countyCode };
      expressList(countyCode)
    }
    // if(reset){
    // }
    if (obj.position?.id < 2) {
      obj.address = obj.position.address
    }
    setSubmitData({ ...obj })

  };
  useEffect(() => {
    let obj = { ...iniValue, ...data };
    freeWay(obj);
  }, [data]);
  useEffect(() => {
    //國道分隊&休息站清單
    //1:國道分隊； 2:休息站
    if (submitData?.freeway_type?.id <= 2) {
      GetDivisionAndReststop(submitData.freeway.freewayListID).then((res) => {
        if (res?.statusCode === 200)
          setFreeWayOptions({
            1: res.result.filter((r) => r.type === "1"),
            2: res.result.filter((r) => r.type === "2"),
          });
      });
    }
  }, [submitData])

  // const fetchIni = async () => {

  // };
  // useEffect(() => {
  //   fetchIni();
  // }, []);
  return (
    <div className="container">
      <div className="page-header">
        <button className="btn-circle" onClick={onBack}>
          <Image src="/images/icons/arrow_left.svg" />
        </button>
        <div className="page_header__title">
          <h1 className="font-heading">位置設定</h1>
          <p className="text-secondary text-scale-02">
            這將幫助技師更快的找到您
          </p>
          {parameters && (
            <Toggle
              style={{ marginTop: 16 }}
              defaultValue={submitData.position}
              label="車輛所在的位置是？"
              list={parameters.LocationType.data}
              onChange={(res) => {
                setSelectOptions({ freeway: selectOptions.freeway });
                let obj = {
                  ...iniValue,
                  city: data.city,
                  town: data.town,
                  position: { ...data.position, ...res },
                }
                freeWay(obj, 'reset')
              }}
            />
          )}
        </div>
      </div>
      <div>
        <div style={{ flexGrow: 1 }} className="grid-gap-24">
          {/* 地址欄位 */}
          {submitData.position?.id < 2 && (
            <Input
              defaultValue={submitData.address}
              closeable
              error={error}
              errorText={error ? "查無此地址座標，請輸入正確的地址。" : ""}
              onChange={(val) => setSubmitData({ ...submitData, address: val })}
              placeholder={"請輸入"}
            />
          )}
          {/* 停車場 */}
          {submitData.position?.id === 1 && (
            <>
              <Toggle
                info="若車輛故障於地下室/立體停車場，將向您收取樓層服務費用"
                defaultValue={submitData.type}
                label="停車場類型？"
                list={[
                  { name: "平面", id: 0 },
                  { name: "地下室/立體", id: 1 },
                ]}
                onChange={(data) =>

                  setSubmitData({
                    ...submitData,
                    type: data,
                    isLimitHeight: data.id ? true : false
                  })
                }
              />
              {submitData.type?.id === 1 && (
                <Number
                  type="floor"
                  // min={0}
                  label="車輛所在樓層？"
                  defaultValue={submitData.floor}
                  digit={1}
                  // numDigit={1}
                  changeFn={(val) =>
                    setSubmitData({ ...submitData, floor: val })
                  }
                />
              )}
              <Switch
                // style={{ marginTop: 24 }}
                title="現場有無高度限制"
                defaultValue={submitData.isLimitHeight}
                info="如抵達現場碰上限高問題無法施作，將收取空趟費。"
                onChange={(val) =>
                  setSubmitData({ ...submitData, isLimitHeight: val })
                }
              />
              {submitData.isLimitHeight && (
                <>
                  <Number
                    min={0.1}
                    label="高度限制(公尺)"
                    defaultValue={submitData.limitHeight}
                    digit={0.1}
                    numDigit={1}
                    changeFn={(val) =>
                      setSubmitData({ ...submitData, limitHeight: val })
                    }
                  />
                </>
              )}
            </>
          )}
          {submitData.position?.id > 1 && <Accordion options={options} />}

          {submitData.position?.id === 2 && (
            <>
              <Select
                label="國道別"
                defaultValue={submitData.freeway}
                options={selectOptions.freeway || []}
                placeholder="點擊選擇"
                onChange={(data) => {
                  let obj = { ...submitData };
                  obj.freeway = data;
                  delete obj.freeway_type;
                  setSubmitData(obj);

                }}
              />
            </>
          )}

          {submitData.position?.id === 2 && submitData.freeway && (
            <div>
              <Toggle
                // style={{ marginTop: 16 }}
                defaultValue={submitData.freeway_type}
                label="所在位置"
                list={[
                  { id: 3, name: "車道中", value: "3" },
                  { id: 4, name: "路肩", value: "4" },
                  ...parameters.DivisionAndReststopsTypes.data,
                ]}
                onChange={(data) => {
                  let obj = { ...submitData };
                  obj.freeway_type = data;
                  delete obj.freeway_sub;
                  delete obj.direction;
                  delete obj.mileage;
                  setSubmitData(obj);
                  setMileageError(false);
                }}
              />
              {submitData.freeway_type?.id > 2 && (
                <Toggle
                  style={{ marginTop: 8 }}
                  defaultValue={submitData.direction}
                  list={submitData.freeway.directions.map((d) => ({
                    name: d,
                    value: d,
                    id: d,
                  }))}
                  onChange={(data) => {
                    setSubmitData({ ...submitData, direction: data });
                  }}
                />
              )}
            </div>
          )}

          {submitData.freeway_type?.id <= 2 && (
            <div>
              <Select
                search
                placeholder={`輸入${submitData.freeway_type.name}名稱關鍵字`}
                defaultValue={submitData.freeway_sub}
                options={freeWayOptions[submitData.freeway_type.id]}
                onChange={(data) => {
                  let obj = { ...submitData };
                  obj.freeway_sub = data;
                  if (data.directionInfos.length === 1) {
                    let info = data.directionInfos[0];
                    obj.direction = {
                      id: info.freewayRegionId,
                      name: info.direction,
                    };
                  } else {
                    delete obj.direction;
                  }

                  setSubmitData(obj);
                }}
              />
              {submitData.freeway_sub?.directionInfos.length > 1 && (
                <Toggle
                  style={{ marginTop: 8 }}
                  defaultValue={submitData.direction}
                  list={submitData.freeway_sub.directionInfos.map((d) => ({
                    id: d.freewayRegionId,
                    name: d.direction,
                  }))}
                  onChange={(data) => {
                    setSubmitData({ ...submitData, direction: data });
                  }}
                />
              )}
            </div>
          )}

          {submitData.position?.id === 3 && (
            <>
              <Select
                label="所在縣市"
                placeholder="點擊選擇"
                defaultValue={
                  submitData.city.countyCode ? submitData.city : null
                }
                options={countyOption}
                onChange={(data) => {
                  let obj = { ...submitData };
                  obj.city = data;
                  expressList(data.countyCode)
                  delete obj.expressway_id;
                  delete obj.express_location;
                  delete obj.direction;
                  delete obj.mileage;
                  setSubmitData(obj);
                }}
              />
              <Select
                placeholder="點選選擇"
                label="快速道路名稱"
                defaultValue={submitData.expressway_id}
                options={selectOptions.express || []}
                onChange={(data) => {
                  let obj = { ...submitData };
                  obj.expressway_id = data;
                  delete obj.express_location;
                  delete obj.direction;
                  delete obj.mileage;
                  setSubmitData(obj);
                }}
              />
              <div>
                <Toggle
                  defaultValue={submitData.express_location || null}
                  label="所在位置"
                  list={[
                    { name: "車道中", id: 1 },
                    { name: "路肩", id: 2 },
                  ]}
                  onChange={(data) =>
                    setSubmitData({ ...submitData, express_location: data })
                  }
                />
                {submitData.expressway_id && (
                  <>
                    <Toggle
                      style={{ marginTop: 8 }}
                      defaultValue={submitData.direction}
                      list={submitData.expressway_id.directions.map((d) => ({
                        id: d,
                        name: d,
                      }))}
                      onChange={(data) =>
                        setSubmitData({ ...submitData, direction: data })
                      }
                    />
                    <div style={{ marginTop: 24 }}>
                      <Input
                        label="所在里程數(k)"
                        placeholder="請輸入"
                        info="每 100 公尺會有綠色牌子標示公里數，請參考該標示填寫。"
                        defaultValue={submitData.mileage}
                        rules={[
                          {
                            type: "range",
                            min: submitData.expressway_id?.minKM,
                            max: submitData.expressway_id.maxKM,
                            message: `僅接受 ${submitData.expressway_id.minKM} 至 ${submitData.expressway_id.maxKM} 的里程數，請確認輸入正確如您所在位置無法查看，請勾選下方選項`,
                          },
                        ]}
                        onChange={(data) => {
                          setMileageError(!data ? true : false);
                          let obj = { ...submitData };
                          obj.mileage = data;
                          delete obj.unseenMileage;
                          setSubmitData(obj);
                        }}
                      />
                    </div>

                    {(mileageError || submitData.unseenMileage) && (
                      <div style={{ marginTop: 24 }}>
                        <Checkbox
                          defaultValue={submitData.unseenMileage}
                          label="我看不到里程牌"
                          onChange={(data) => {
                            setSubmitData({
                              ...submitData,
                              unseenMileage: data,
                            });
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
          {submitData.position?.id === 2 && submitData.freeway_type?.id > 2 && (
            <>
              <Input
                label="所在里程數(k)"
                placeholder="請輸入"
                defaultValue={submitData.mileage}
                rules={[
                  {
                    type: "range",
                    min: submitData.freeway.minKM,
                    max: submitData.freeway.maxKM,
                    message: `僅接受 ${submitData.freeway.minKM} 至 ${submitData.freeway.maxKM} 的里程數，請確認輸入正確或調整後再試。`,
                  },
                ]}
                onChange={(data) => {
                  setMileageError(!data ? true : false);
                  let obj = { ...submitData };
                  obj.mileage = data;
                  delete obj.unseenMileage;
                  setSubmitData(obj);
                }}
              />
              {mileageError && (
                <Checkbox
                  label="我看不到里程牌"
                  onChange={(data) => {
                    setSubmitData({ ...submitData, unseenMileage: data });
                  }}
                />
              )}
            </>
          )}
        </div>
        <button
          className="btn"
          disabled={disabledBtn()}
          onClick={() => _onSubmit()}
        >
          確定
        </button>
      </div>
    </div>
  );
};

export default Position;
